export default function Quote() {
  return (
    <section className="bg-accent-500 px-4 md:px-8 py-16 md:py-24 text-center">
      <span className="w-10 h-10 mx-auto flex items-center justify-center text-foreground-950/60">
        <i className="ri-double-quotes-l text-4xl"></i>
      </span>
      <blockquote className="font-heading font-bold italic text-3xl md:text-5xl lg:text-6xl leading-[1.1] text-foreground-950 max-w-4xl mx-auto mt-4">
        The most important shot in golf is the next one.
      </blockquote>
      <p className="mt-6 font-label uppercase tracking-[0.28em] text-sm font-bold text-foreground-950/80">— Ben Hogan</p>
    </section>
  );
}